import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import ToolSafetyDisclaimer from '../components/tools/ToolSafetyDisclaimer';
import FuseRatingCalculator from '../components/tools/FuseRatingCalculator';

const FuseRatingCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="fuse-rating-calculator-page">
      <PageHero
        eyebrow="Power Electronics"
        title="Fuse Rating Calculator"
        description="Recommend wire gauge and fuse rating for an LV automotive or EV/HV circuit from load, run length, ambient conditions, and available fault current."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="fuse-rating-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <ToolSafetyDisclaimer standards="general fuse-selection practice (IEC 60269, ISO 8820, ISO 6469-3)" />
          <FuseRatingCalculator />
          <ToolGuideCta guidePath="/tools/power-electronics/fuse-rating-calculator/guide" toolName="Fuse Rating Calculator" />
        </div>
      </section>
    </div>
  );
};

export default FuseRatingCalculatorPage;
